import React, { useState } from "react";
import { Button, Badge } from "antd";
import { BellOutlined } from "@ant-design/icons";
import { useNotifications } from "../../context/NotificationContext";
import CommunicationsModal from "./CommunicationsModal";

const Notifications: React.FC = () => {
	const { unreadCount } = useNotifications();
	const [drawerOpen, setDrawerOpen] = useState(false);

	return (
		<>
			<Badge count={unreadCount} size="small" offset={[-4, 4]}>
				<Button
					data-testid="notifications-bell-btn"
					type="text"
					icon={<BellOutlined />}
					onClick={() => setDrawerOpen(true)}
					style={{
						width: 36,
						height: 36,
						display: "flex",
						alignItems: "center",
						justifyContent: "center",
						borderRadius: 8,
						fontSize: 16,
						color: drawerOpen ? "var(--mg-primary)" : "var(--mg-text-secondary)",
						background: drawerOpen ? "var(--mg-primary-bg)" : "transparent",
					}}
				/>
			</Badge>
			<CommunicationsModal open={drawerOpen} onClose={() => setDrawerOpen(false)} />
		</>
	);
};

export default Notifications;
